import CrHead from '../lib/components/cr-head';
import CrHomepageNav from '../lib/components/cr-homepage-nav';
import {
  Masthead,
  Advertising,
  JobsThatScale,
  Testimonials,
  Banners,
  ForEmployers,
  NewJobPostings
} from '../lib/components/home';
import Footer from '../lib/components/footer';

import GoogleAnalyticsBase from '../lib/components/analytics/google-analytics-base';
import FacebookAnalyticsBase from '../lib/components/analytics/facebook-analytics-base';

const Home = () => {
  return (
    <>
      <CrHead>
        <title>
          Part-time seasonal internship apprenticeship entry-level jobs careers students recent
          grads
        </title>
        <meta
          property="og:title"
          content="Part-time seasonal internship apprenticeship entry-level jobs careers students recent grads"
        />
        <meta
          name="title"
          content="Part-time seasonal internship apprenticeship entry-level jobs careers students recent grads"
        />
      </CrHead>
      <div>
        <GoogleAnalyticsBase />
        <FacebookAnalyticsBase />
        <CrHomepageNav />
        <main id="site-main" className="angled-bg top-500">
          <div className="container-xl pt-5 mt-4">
            <Masthead />
            <NewJobPostings />
          </div>
          <ForEmployers />

          <JobsThatScale />
          <Advertising />

          <div className="py-5 background-plum">
            <Testimonials />
            <Banners />
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Home;
